import type { ReactNode } from "react";
import { FormErrorText } from "@apac/form-ui";
import { useModuleBEM } from "@b2bportal/core-themes";
import clsx from "clsx";
import styles from "./styles.module.scss";

export interface ControlledFormControlWrapperProps {
  className?: string;
  label?: ReactNode;
  disabled?: boolean;
  error?: ReactNode;
  helperText?: ReactNode;
  required?: boolean;
  children?: ReactNode;
  /** Id of the control this label names, so the label associates via `htmlFor` (WCAG 1.3.1 / 4.1.2). */
  htmlFor?: string;
}

export const ControlledFormControlWrapper = ({
  className,
  children,
  label,
  error,
  helperText,
  required,
  htmlFor,
}: ControlledFormControlWrapperProps): JSX.Element => {
  const [block, cn] = useModuleBEM(styles, "FormControlWrapper");
  return (
    <div className={clsx(block, className)}>
      {label && (
        <label className={cn("label", { required })} htmlFor={htmlFor}>
          {label}
        </label>
      )}
      {children}
      {error && <FormErrorText error={error} />}
      {helperText && <div className={cn("helper-text")}>{helperText}</div>}
    </div>
  );
};
